import { Breadcrumb } from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { checkPermissionAction } from "../../../Reusable/Store/Action/AuthPermissionsAction";
import commonCssStyle from "../../UI/CommonCss.module.css";
import PermissionMessage from "../../UI/PermissionMessage";

function BreadcrumbForEmployees(props) {
  const navigate = useNavigate();
  const [openPMModal, setOpenPMModal] = useState({
    open: false,
    permission: "",
  });
  const array = ["Home", "Employee", "Employee details"];
  return (
    <>
      <Breadcrumb>
        {props.slide &&
          props.slide.map((data, index) => {
            return (
              <Breadcrumb.Item key={index}>
                <p
                  className={` ${commonCssStyle.breadcrumbText} ${commonCssStyle.coursorPointer} ${commonCssStyle.marginBottomRemove}`}
                  onClick={() => {
                    if (data === 1) {
                      props.getCheckPermissionHandler(
                        "dashboard",
                        (success) => {
                          if (success) {
                            navigate("/dashboard");
                          } else {
                            setOpenPMModal({
                              open: true,
                              permission: "Dashboard",
                            });
                          }
                        }
                      );
                    } else if (data === 2) {
                      props.permissions &&
                      props.permissions.find(
                        (data) =>
                          data === "employees-list" ||
                          data === "employees-add" ||
                          data === "employees-edit" ||
                          data === "employees-delete" ||
                          data === "employees-detail" ||
                          data === "employees-assign-role" ||
                          data === "employees-assign-permission" ||
                          data === "employees-timeline" ||
                          data === "employees-task-list" ||
                          data === "employee-download-recording" ||
                          data === "employee-call"
                      )
                        ? navigate("/employee")
                        : setOpenPMModal({
                            open: true,
                            permission: "Employee",
                          });
                    }
                  }}
                >
                  {array[index]}
                </p>
              </Breadcrumb.Item>
            );
          })}
      </Breadcrumb>
      <PermissionMessage
        onOpenPMModal={openPMModal}
        onClosePMModal={() => {
          setOpenPMModal({ open: false, permission: "" });
          props.setIsHavepermissionsHandler(false);
        }}
      />
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    permissions: state.authpermissions.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCheckPermissionHandler: (id, callback) => {
      dispatch(checkPermissionAction(id, callback));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BreadcrumbForEmployees);
